import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { getLoginRedirectPath } from '../authRedirects'
import { useAuth } from '../contexts/AuthContext'
import { FourOhFour } from '../pages/404'

export const LoggedOutRedirect = () => {
  const { isLoggedIn } = useAuth()
  const location = useLocation()

  if (!isLoggedIn) {
    return <Navigate to={getLoginRedirectPath(location.pathname, location.search, location.hash)} replace />
  }

  return <FourOhFour />
}
